import { KeyCodes } from '../../util/Keyboard';
import { ReduxAction } from '../core';
import { UIAction } from './actions';
import { UIState } from './types';
import { toShortDateString } from '../../util/Date';

const initialState: UIState = {
  showSidePanel: false,
  expandNav: false,
  date: toShortDateString(new Date()),
  markets: [],
  services: ['ALL'],
  visitCode: '',
  visitStatus: 'NOT_FINISHED',
  visitFilterText: '',
  partnerFilterText: '',
  providerId: '',
  claimsStatus: [],
  claimsSearchText: '',
  claimsFromDate: '',
  claimsToDate: toShortDateString(new Date()),
  onSiteFromDate: toShortDateString(new Date()),
  onSiteToDate: toShortDateString(new Date(new Date().setDate(new Date().getDate() + 7))),
  onSiteVisitFilterText: '',
  onSiteEventsFilterText: '',
  onSiteManagerActiveItem: 'appointments',
  onSiteEventActiveItem: '',
  partnerActiveItem: '',
  optionKeyDepressed: false,
  showPairingRules: false,
  schedulingExpand: [],
  collapsibleSectionsClosed: ['visit_debug', 'hub_debug'],
  lastMapLocation: { lat: 34.0333727, lng: -118.4542063 },
};

export function uiReducer(state: UIState = initialState, action: ReduxAction<any>): UIState {
  switch (action.type) {
    case UIAction.SHOW_SIDE_PANEL:
      return {
        ...state,
        showSidePanel: true,
      };
    case UIAction.HIDE_SIDE_PANEL:
      return {
        ...state,
        showSidePanel: false,
      };

    case UIAction.SET_EXPAND_NAV:
      return {
        ...state,
        expandNav: action.data as boolean,
      };

    case UIAction.SET_DATE:
      return {
        ...state,
        date: action.data as string,
      };
    case UIAction.SET_MARKETS:
      return {
        ...state,
        markets: action.data as string[],
      };
    case UIAction.SET_SERVICES:
      return {
        ...state,
        services: action.data as string[],
      };
    case UIAction.SET_VISIT_CODE:
      return {
        ...state,
        visitCode: action.data as string,
      };
    case UIAction.SET_VISIT_STATUS:
      return {
        ...state,
        visitStatus: action.data as string,
      };
    case UIAction.SET_VISIT_FILTER_TEXT:
      return {
        ...state,
        visitFilterText: action.data as string,
      };
    case UIAction.SET_PARTNER_FILTER_TEXT:
      return {
        ...state,
        partnerFilterText: action.data as string,
      };
    case UIAction.SET_PROVIDER_ID:
      return {
        ...state,
        providerId: action.data as string,
      };

    case UIAction.SET_CLAIMS_STATUS:
      return {
        ...state,
        claimsStatus: action.data as string[],
      };
    case UIAction.SET_CLAIMS_SEARCH_TEXT:
      return {
        ...state,
        claimsSearchText: action.data as string,
      };
    case UIAction.SET_CLAIMS_FROM_DATE:
      return {
        ...state,
        claimsFromDate: action.data as string,
      };
    case UIAction.SET_CLAIMS_TO_DATE:
      return {
        ...state,
        claimsToDate: action.data as string,
      };
    case UIAction.SET_ONSITES_FROM_DATE:
      return {
        ...state,
        onSiteFromDate: action.data as string,
      };
    case UIAction.SET_ONSITES_TO_DATE:
      return {
        ...state,
        onSiteToDate: action.data as string,
      };
    case UIAction.SET_ONSITES_VISIT_FILTER_TEXT:
      return {
        ...state,
        onSiteVisitFilterText: action.data as string,
      };
    case UIAction.SET_ONSITE_EVENTS_FILTER_TEXT:
      return {
        ...state,
        onSiteEventsFilterText: action.data as string,
      };
    case UIAction.SET_ONSITE_MANAGER_ACTIVE_KEY:
      return {
        ...state,
        onSiteManagerActiveItem: action.data as string,
      };
    case UIAction.SET_ONSITE_EVENT_ACTIVE_KEY:
      return {
        ...state,
        onSiteEventActiveItem: action.data as string,
      };
    case UIAction.SET_PARTNER_ACTIVE_KEY:
      return {
        ...state,
        partnerActiveItem: action.data as string,
      };
    case UIAction.KEY_STATE_CHANGE:
      if (action.data.keyCode === KeyCodes.option) {
        return {
          ...state,
          optionKeyDepressed: action.data.pressed || false,
        };
      } else {
        return state;
      }
    case UIAction.SET_SHOW_PAIRING_RULES:
      return {
        ...state,
        showPairingRules: action.data,
      };
    case UIAction.SET_SCHEDULING_EXPANDED_GROUPS:
      return {
        ...state,
        schedulingExpand: action.data,
      };
    case UIAction.SET_COLLAPSIBLE_SECTIONS_CLOSED:
      return {
        ...state,
        collapsibleSectionsClosed: action.data,
      };
    case UIAction.SET_LAST_MAP_LOCATION:
      return {
        ...state,
        lastMapLocation: action.data,
      };
    default:
      return state;
  }
}
